module.exports = __webpack_public_path__ + "img/upload_text.e2141abe.jpg";